import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { HttpService } from '@services/http.service';

import { EndpointParams } from '@models/utils/endpoint-params';
import { Video } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class VideoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    private videoSubject = new BehaviorSubject<Video>(new Video());
    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { video: Video } = { video: new Video() };

    get video(): Observable<Video> {
        return this.videoSubject.asObservable();
    }

    get isLoading(): Observable<boolean> {
        return this.isLoadingSubject.asObservable();
    }

    search(idPackCategoryVideo: number): void {
        this.loading(true);
        this.get(`polaris/virtual/videos/${idPackCategoryVideo}`, this.defaultEndpointParams).subscribe(
            data => {
                this.dataStore.video = new Video().build(data);

                this.next();
                this.loading(false);
            }
        );
    }

    validate(idVideo: number): Observable<any> {
        return this.put(`virtual/videos/${idVideo}/validate`, { app: 'center', version: 1 });
    }

    private next(): void {
        this.videoSubject.next(this.dataStore.video);
    }

    loading(value: boolean): void {
        this.isLoadingSubject.next(value);
    }
}
